import { DaycareId } from 'src/replicant/daycare';
import StateObserver from 'src/StateObserver';
import { captureGenericError } from 'src/lib/sentry';
import { getPet } from '../pet';
import { LivingRoomPosition } from '../position/PositionModel';
import { petIdleSequence } from '../pet/pet.sequence';
import { getSceneManager } from 'src/lib/utils';

let activeEntrySequence: Promise<void> = Promise.resolve();

export async function daycareEntrySequence(daycareId: DaycareId) {
  const sequence = async () => {
    try {
      await StateObserver.invoke.startDaycare(daycareId);
    } catch (e: any) {
      captureGenericError('Daycare start action failed', e);
      return;
    }

    const pet = getPet();
    await pet.startConversation('daycare_check_in');

    pet.appearance.setAction('hang');
    pet.position.setWandering(false);
    await pet.moveTo({
      scene: getSceneManager().baseSceneId,
      location: 'daycare',
    });

    pet.hide();
  };

  activeEntrySequence = new Promise<void>((resolve) =>
    sequence().finally(resolve),
  );
  await activeEntrySequence;
}

export async function daycareExitSequence(id: DaycareId) {
  await StateObserver.invoke.exitDaycare(id);
  await daycareReturnSequence();
}

export async function daycareReturnSequence() {
  await activeEntrySequence;

  const pet = getPet();
  pet.position.setWandering(false);

  const position: LivingRoomPosition = {
    scene: getSceneManager().baseSceneId,
    location: 'daycare',
  };
  await pet.moveTo(position, 0);

  pet.show();
  pet.appearance.setAction('hang');

  position.location = 'c';
  await pet.moveTo(position);

  await pet.startConversation('daycare_check_out');
  pet.position.setWandering(true);

  // Start pet idle sequence.
  await petIdleSequence();
}
